import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../views/HomePage.vue';
import RegisterPage from '../views/UserRegistrationPage.vue';
import LoginPage from '../views/LoginPage.vue';
import AdminPage from '../views/AdminPage.vue';  // Parent Admin page layout
import AdminHome from '../views/ViewStatisticsPage.vue';  // Admin home page (default)
import RegistrationPaymentSuccessPage from '../views/RegistrationPaymentSuccessPage.vue';  // Registration success page, Payfast will redirect here
import EditLoginDetail from '../views/ManageUserDetailPage.vue';  // Edit login details page
import EditPaymentDetail from '../views/ManagePaymentDetailsPage.vue';  // Edit payment details page
import UploadDocuments from '../views/ManageKnowledgeDocumentsPage.vue';  // Upload documents page
import ChatMessages from '../views/ManageChatMessagesPage.vue';  // New Chat Messages page
import CreateSimpleRagChatbot from '../views/ManageChatbotsPage.vue';  // New Chat Messages page
import auth from '../services/auth';  // Auth service to check login

// Define all routes in the application
const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: { noCache: true },
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterPage,
  },
  {
    path: '/registration-payment-success',
    name: 'RegistrationPaymentSuccess',
    component: RegistrationPaymentSuccessPage,
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminPage,
    meta: { requiresAuth: true },  
    children: [
      {
        path: '',
        name: 'AdminHome',
        component: AdminHome,  
      },
      {
        path: 'manage-users',
        name: 'EditLoginDetail',
        component: EditLoginDetail,
      },
      {
        path: 'manage-payments',
        name: 'EditPaymentDetail',
        component: EditPaymentDetail,
      },
      {
        path: 'manage-knowledge-documents',
        name: 'UploadDocuments',
        component: UploadDocuments,
      },
      {
        path: 'chat-messages', 
        name: 'ChatMessages',
        component: ChatMessages, 
      },
      {
        path: 'manage-chatbots', 
        name: 'CreateSimpleRAGChatbot',
        component: CreateSimpleRagChatbot, 
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',  // Catch-all for undefined routes
    redirect: '/',  // Redirect to the home page
  },
];

// Create the router instance
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Define the navigation guard to check authentication
router.beforeEach((to, from, next) => {
  // Check if the route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!auth.checkAuth()) {
      // If the user is not logged in, redirect to the login page
      next({ name: 'Login' });
    } else {
      // If the user is logged in, proceed to the route
      next();
    }
  } else {
    // If no authentication is required, proceed to the route
    next();
  }
});

export default router;
